export const managedSurveyAssetType = {
  Switchgear: "$UTP2_DEFAULT",
  GisSwitchgear: "$GIS_SWITCHGEAR",
  SwitchgearSimple: "$UTP2_SIMPLE",
  Transformer: "$TRANSFORMER",
  OutdoorSwitchyard: "$OUTDOOR_SWITCHYARD",
  Unknown: "$UNKNOWN",
} as const;

export const UTP2_VARIABLE_CHAR = "$";

export type ManagedSurveyAssetType = (typeof managedSurveyAssetType)[keyof typeof managedSurveyAssetType];

export function getAssetTypeLabel(assetType?: string) {
  if (assetType?.charAt(0) === UTP2_VARIABLE_CHAR) return assetType as ManagedSurveyAssetType;
  const assetTypes = Object.entries(managedSurveyAssetType).map(([value, label]) => ({ value, label }));
  return assetTypes.find((item) => item.value === assetType)?.label ?? "$UTP2_DEFAULT";
}

export function getAssetTypeKey(assetType: ManagedSurveyAssetType): string {
  const keyString = Object.keys(managedSurveyAssetType).find(
    (key) => managedSurveyAssetType[key as keyof typeof managedSurveyAssetType] === assetType,
  );
  return keyString ? keyString : "Unknown";
}

export const flexiSurveyAssetTypeKeys = Object.keys(managedSurveyAssetType).filter((key) => key !== "Unknown");

export function isFlexiSurveyAssetTypeKey(assetTypeKey?: string): boolean {
  if (!assetTypeKey) return false;
  return flexiSurveyAssetTypeKeys.includes(assetTypeKey);
}
